import { imageCoverContainer } from '@helpers/aspectRatio';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { paragraphRegular } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Global/Buttons/Button/Button.styles';
import FormStyles from '@stories/Components/Global/Forms/Form.styles';
import QuantitySelectorStyles from '@stories/Components/Global/QuantitySelector/QuantitySelector.styles';
import styled from 'styled-components';
const Container = styled.div `
  background-color: var(--bgColour);
  padding: ${fluid(14, 16)};
  display: flex;
  flex-direction: column;
  height: 100%;
  position: relative;

  [data-site='ess'] & {
    --borderColour: ${brand.ess.secondary.lightestGrey};
    --bgColour: ${brand.global.white};
    --idColour: ${brand.ess.secondary.darkGrey};
    --priceColour: ${brand.global.red};
    --tickColour: ${brand.global.red};
    --textColour: ${brand.ess.primary};
  }

  [data-site='mep'] & {
    --borderColour: ${brand.mep.secondary.lightestGrey};
    --bgColour: ${brand.global.white};
    --idColour: ${brand.mep.secondary.darkestGrey};
    --priceColour: ${brand.global.red};
    --tickColour: ${brand.global.red};
    --textColour: ${brand.mep.primary};

    border-radius: 8px;
  }
`;
const ImageWrapper = styled.div `
  position: relative;
  padding: ${fluid(6, 12)};
  width: 120px;
  height: 120px;
  flex: 0 0 120px;
  border: 1px solid var(--borderColour);
`;
const Image = styled.img `
  ${imageCoverContainer()}
  object-fit: contain;
`;
const PriceWrapper = styled.div `
  display: flex;
  gap: 5px;
  align-items: flex-end;
  color: var(--priceColour);
  white-space: nowrap;
`;
const Price = styled.span `
  font-size: ${fluid(16, 18)};
  line-height: 24px;

  [data-site='ess'] & {
    ${fonts.daxWide.bold};
  }

  [data-site='mep'] & {
    ${fonts.museoSlab.bold};
  }
`;
const Suffix = styled.span `
  ${fonts.daxWide.regular};

  font-size: ${fluid(10, 12)};
  line-height: ${fluid(18, 20)};
  text-transform: uppercase;
`;
const TopWrapper = styled.div `
  display: flex;
  gap: ${fluid(12, 16)} ${fluid(10, 20)};
  align-items: flex-start;
  margin: 0 0 ${fluid(14, 20)};
`;
const TitlePriceWrapper = styled.div ``;
const Title = styled.h3 `
  ${paragraphRegular};
  ${fonts.daxWide.bold};

  margin: 0 0 4px;
`;
const Id = styled.span `
  ${paragraphRegular};

  color: var(--idColour);
  margin: 0 0 10px;
`;
const Description = styled.p `
  ${fonts.daxWide.regular};

  font-size: ${fluid(14, 16)};
  line-height: ${fluid(24, 26)};
  color: var(--idColour);
  margin: 0 0 ${fluid(32, 40)};
`;
const QuantityPriceWrapper = styled.div `
  display: flex;
  padding-top: ${fluid(14, 16)};
  gap: 12px;
  border-top: 1px solid var(--borderColour);
  margin: auto 0 0;

  ${FormStyles.Label} {
    display: none;
  }

  ${ButtonStyles.Container} {
    flex: 1;
    justify-content: center;
    text-align: center;
  }

  ${ButtonStyles.IconWrapper} {
    margin-left: 0;
  }

  [data-site='mep'] & {
    ${QuantitySelectorStyles.Container} {
      --bgColour: ${brand.mep.secondary.lightestGrey};
    }
  }
`;
const UpsellCardStyles = {
    Container,
    QuantityPriceWrapper,
    PriceWrapper,
    Price,
    Suffix,
    TitlePriceWrapper,
    ImageWrapper,
    Image,
    TopWrapper,
    Title,
    Id,
    Description,
};
export default UpsellCardStyles;
